import { TFunction } from 'react-i18next';

interface StockProviders {
  shutterstock: string;
  gettyImages: string;
  designAuthor: string;
}

export default function generateAuthorHtml(
  isShutterStock: boolean,
  isGettyImagesDesign: boolean,
  nonExternalStockDesign: boolean,
  t: TFunction,
  authorClass: string,
  author?: string,
): string {
  if (!author) {
    return '';
  }

  const stockProviders: StockProviders = {
    shutterstock: 'txt_design_author_from_shutterstock',
    gettyImages: 'txt_design_author_from_gettyimages',
    designAuthor: 'txt_design_author',
  };

  let provider: keyof StockProviders | '' = '';
  if (isShutterStock) {
    provider = 'shutterstock';
  } else if (isGettyImagesDesign) {
    provider = 'gettyImages';
  } else if (nonExternalStockDesign) {
    provider = 'designAuthor';
  }

  if (!provider) {
    return '';
  }

  const translationKey = stockProviders[provider];
  const authorMarkup = `<span class=${authorClass}>${author}</span>`;
  const translationParams = { author: authorMarkup };
  return t(translationKey, translationParams);
}
